module.exports = __webpack_public_path__ + "static/img/1mobile.08d7a31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/1mobile.jpg
// module id = c8VA
// module chunks = 1